// LendingTree credit score ranges
export var creditScoreRange = [[760], [740, 759], [720, 739], [700, 719], [680, 699], [660, 679], [640, 659], [620, 639], [580, 619], [300, 579]];
export var bankruptcyAndForeclosureRange = [[0, 0], [1, 12], [13, 24], [25, 36], [37, 48], [49, 60], [61, 72], [73, 84], [85]];